import { apiClient } from '@/services';

export const R6Service = {
  checkR6IsUp() {
    return apiClient.get('/r6/is-up');
  },
};